import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabaseClient } from '../../utils/supabase';

export const StripeModeBadge: React.FC = () => {
  const { data: mode } = useQuery({
    // REG-771: Stripe is retired; GoACH staging = test, GoACH live = live.
    queryKey: ['ach_provider_config', 'mode_badge'],
    queryFn: async () => {
      const { data } = await (supabaseClient as any)
        .from('ach_provider_config')
        .select('provider, stripe_mode, goach_mode')
        .single();
      if (data?.provider === 'goach') return data.goach_mode === 'live' ? 'live' : 'test';
      return (data?.stripe_mode as string) ?? 'test';
    },
    staleTime: 30_000,
  });

  if (!mode) return null;

  const isLive = mode === 'live';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 10px',
        fontSize: 11.5,
        fontWeight: 700,
        borderRadius: 4,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        background: isLive ? 'var(--red-bg)' : 'var(--amber-bg)',
        color: isLive ? 'var(--red)' : 'var(--amber)',
      }}
    >
      {isLive ? 'LIVE MODE' : 'TEST MODE'}
    </span>
  );
};
